// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Yz+RG","graph":"styles_graph__6bMV2","headings":"styles_headings__k7TBR","heart_rate":"styles_heart_rate__AOCXU","tooltip":"styles_tooltip__pfQkA"};